/**
 * Wraps a callback-based function in a Promise.
 *
 * Useful for converting callback-style APIs to Promise-based APIs.
 * The callback receives resolve and reject functions to control the Promise.
 *
 * @param callback - Function that receives resolve/reject and performs the action
 * @returns Promise that resolves/rejects based on callback execution
 *
 * @example
 * ```typescript
 * const promise = promiseWrapper((resolve, reject) => {
 *   setTimeout(() => resolve('done'), 1000);
 * });
 * ```
 */
export const promiseWrapper = (callback) => {
    return new Promise((resolve, reject) => callback(resolve, reject));
};
/**
 * Type guard that checks if a value is a Promise.
 *
 * Checks for both native Promise instances and thenable objects (duck typing).
 *
 * @param obj - Value to check
 * @returns true if the value is a Promise or thenable
 */
export const isPromise = (obj) => {
    return obj instanceof Promise || (!!obj && (typeof obj.then === 'function' && typeof obj.catch === 'function'));
};
//# sourceMappingURL=promise-tools.js.map